import axios, { AxiosProgressEvent } from 'axios';

export class APIService {
  token?: string;
  baseURL: string;

  constructor(baseURL: string, token?: string) {
    this.token = token;
    this.baseURL = baseURL;
  }

  async get(url: string, body?: object): Promise<{ data: object; status: number }> {
    return await axios.get(url, {
      withCredentials: !this.token,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
      },
      params: { ...(body || {}) },
      baseURL: this.baseURL,
    });
  }

  async post(
    url: string,
    body?: object,
    multipart?: boolean
  ): Promise<{ data: object; status: number }> {
    return await axios.post(
      url,
      { ...body },
      {
        withCredentials: !this.token,
        data: { ...body },
        baseURL: this.baseURL,
        headers: {
          'Content-Type': multipart ? 'multipart/form-data' : 'application/json',
          'Access-Control-Allow-Origin': '*',
          ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
        },
      }
    );
  }

  async patch(
    url: string,
    body?: object,
    multipart?: boolean
  ): Promise<{ data: object; status: number }> {
    return await axios.patch(
      url,
      { ...body },
      {
        withCredentials: !this.token,
        data: { ...body },
        baseURL: this.baseURL,
        headers: {
          'Content-Type': multipart ? 'multipart/form-data' : 'application/json',
          'Access-Control-Allow-Origin': '*',
          ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
        },
      }
    );
  }

  // Temporary fix!
  async postWithCredentials(
    url: string,
    body?: object,
    multipart?: boolean
  ): Promise<{ data: object; status: number }> {
    return await axios.post(
      url,
      { ...body },
      {
        withCredentials: !!this.token,
        data: { ...body },
        baseURL: this.baseURL,
        headers: {
          'Content-Type': multipart ? 'multipart/form-data' : 'application/json',
          'Access-Control-Allow-Origin': '*',
          ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
        },
      }
    );
  }

  async put(
    url: string,
    body?: object,
    multipart?: boolean
  ): Promise<{ data: object; status: number }> {
    return await axios.put(
      url,
      { ...body },
      {
        withCredentials: !this.token,
        data: { ...body },
        baseURL: this.baseURL,
        headers: {
          'Content-Type': multipart ? 'multipart/form-data' : 'application/json',
          'Access-Control-Allow-Origin': '*',
          ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
        },
      }
    );
  }

  async delete(url: string, body?: object): Promise<{ data: object; status: number }> {
    return await axios.delete(url, {
      withCredentials: !this.token,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
      },
      params: { ...(body || {}) },
      baseURL: this.baseURL,
    });
  }

  async postFormData(
    url: string,
    formData: FormData,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<{ data: object; status: number }> {
    return await axios.post(url, formData, {
      withCredentials: !this.token,
      baseURL: this.baseURL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
      },
      onUploadProgress,
    });
  }

  async postRaw(url: string, body: string): Promise<{ data: object; status: number }> {
    return await axios.post(url, body, {
      withCredentials: !this.token,
      data: body,
      baseURL: this.baseURL,
      headers: {
        'Access-Control-Allow-Origin': '*',
        ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
      },
    });
  }
  /* cspell:disable */
  async postOnsite(
    url: string,
    token: string,
    body?: object
  ): Promise<{ data: object; status: number }> {
    return await axios.post(
      url,
      { ...body },
      {
        data: { ...body },
        baseURL: this.baseURL,
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          ...(token ? { Authorization: `Onsite ${token}` } : {}),
        },
      }
    );
  }
}
